import { FC, SVGProps } from 'react'

import canadaFlag from '@src/components/icons/canada.inline.svg'
import usaFlag from '@src/components/icons/usa.inline.svg'
import { TCountry } from '@src/config/i18n.config'

export const COUNTRY_CONFIG: Record<TCountry, { flag: FC<SVGProps<SVGElement>> }> = {
  us: {
    flag: usaFlag,
  },
  ca: {
    flag: canadaFlag,
  },
}

export const LOCALE_STANDARD_FORMAT = 'en-US'
export const LOCALE_STANDARD_FORMAT_CANADA = 'en-CA'
export const LOCALE_STANDARD_FORMAT_CANADA_FRENCH = 'fr-CA'

export const KLARNA_REGION_WISE_CLIENT_ID_CONFIG = {
  us: '0b7506d8-61c1-579e-af8a-318251fac4af',
  ca: 'de6c249a-249b-548b-80e8-ff6a227f8957',
}
